import React from 'react';

const SvgChevronUp: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.768 16.384"
      {...props}
    >
      <path
        d="M27.646 14.263L14.884 1.5 2.122 14.262"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgChevronUp;
